<template>
  <div style="background: white; border-radius: 10px; border: 1px solid #cccccc; padding-bottom: 20px">
    <div class="profileTitle">
      <div class="chartTitle">
        <h3>Resiliency Profile</h3>
        <div class="profileContent">
          Your results are: <br />
          <div class="profileItem">
            Routine (Task) Performance:<span>{{ resiliency[0] }}</span> , Rate: <span>{{ resiliencyRate[0] }}%</span> , <br />
            Teamplayer ("Citizenship") Performance:<span>{{ resiliency[1] }}</span> , Rate: <span>{{ resiliencyRate[1] }}%</span> , <br />
            Adaptive:<span>{{ resiliency[2] }}</span> , Rate: <span>{{ resiliencyRate[2] }}%</span> , <br />
            Resilience:<span>{{ resiliency[3] }}</span> , Rate: <span>{{ resiliencyRate[3] }}%</span> , <br />
            CWB:<span>{{ resiliency[4] }}</span> , Rate: <span>{{ resiliencyRate[4] }}%</span> , <br />
            LDR EMERGENCE:<span>{{ resiliency[5] }}</span> , Rate: <span>{{ resiliencyRate[5] }}%</span> , <br />
            LDR EFFECTIVENESS:<span>{{ resiliency[6] }}</span>, Rate: <span>{{ resiliencyRate[6] }}%</span>
          </div>
        </div>
        <p>Research shows that personalities seek out and flourish in career environments they fit and that jobs and career environments are classifiable by the personalities that flourish in them.</p>
      </div>
      <GChart class="GoogleChart" type="PieChart" :data="chartData" :options="chartOptions" />
    </div>
  </div>
</template>

<script>
import { GChart } from "vue-google-charts";
export default {
  props: ["resiliency", "resiliencyRate"],
  name: "resiliencyChart",
  components: {
    GChart,
  },
  methods: {
    update() {
      this.chartData[1][1] = Number(this.resiliency[0].replace("-", ""));
      this.chartData[2][1] = Number(this.resiliency[1].replace("-", ""));
      this.chartData[3][1] = Number(this.resiliency[2].replace("-", ""));
      this.chartData[4][1] = Number(this.resiliency[3].replace("-", ""));
      this.chartData[5][1] = Number(this.resiliency[4].replace("-", ""));
      this.chartData[6][1] = Number(this.resiliency[5].replace("-",""));
      this.chartData[7][1] = Number(this.resiliency[6].replace("-",""));
    },
  },
  mounted() {
    console.log("去的数据", this.resiliency);
    this.chartData[1][1] = Number(this.resiliency[0].replace("-", ""));
    this.chartData[2][1] = Number(this.resiliency[1].replace("-", ""));
    this.chartData[3][1] = Number(this.resiliency[2].replace("-", ""));
    this.chartData[4][1] = Number(this.resiliency[3].replace("-", ""));
    this.chartData[5][1] = Number(this.resiliency[4].replace("-", ""));
    this.chartData[6][1] = Number(this.resiliency[5].replace("-",""));
    this.chartData[7][1] = Number(this.resiliency[6].replace("-",""));
  },
  data() {
    return {
      chartData: [
        ["Task", "Hours per Day"],
        ["Routine (Task) Performance", 1],
        ['Teamplayer ("Citizenship") Performance', 1],
        ["Adaptive", 1],
        ["Resilience", 1],
        ["CBW", 1],
        ["LDR EMERGENCE", 1],
        ["LDR EFFECTIVENESS", 1],
      ],
      chartOptions: {
        pieSliceText: "none",
        // colors: ["rgb(244,244,244)", "#ff9900", "#ffa928", "#ffba51", "#ffca7a"],
        colors: ["rgb(244,244,244)", "#ff9900", "#ffa928", "#ffba51", "#ffca7a","#17a2b8","#20c997"],
        legend: { position: "labeled" },
        width: "340",
        height: "180",
      },
    };
  },
};
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
}
.profileTitle {
  width: 100%;
  padding: 20px 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}
.GoogleChart {
}
.chartTitle {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.chartTitle h3 {
  margin-bottom: 10px;
  font-size: 26px;
}
.chartTitle p {
  margin-top: 10px;
}

.profileItem {
  color: balck;
  font-weight: 510;
  line-height: 1.5;
  padding-left: 1em;
}

.profileItem span {
  padding-left: 0.5em;
  color: orangered;
}

.profiletable {
  padding: 0 20px;
  box-sizing: border-box;
}
.prorow {
  display: flex;
}
.pro_l {
  flex: 0 0 120px;
  padding-left: 10px;
  min-height: 30px;
  display: flex;
  align-items: center;
  text-align: center;
  background: rgb(213, 209, 200);
  color: rgb(113, 112, 132);
  font-size: 14px;
  font-weight: bold;
}
.pro_r {
  color: #333;
  flex: 1;
  padding: 10px;
  display: flex;
  font-size: 14px;
  align-items: center;
  border-bottom: 1px solid rgb(213, 209, 200);
  border-right: 1px solid rgb(213, 209, 200);
}
.ground {
  background: rgb(213, 209, 200);
  border: none;
  color: rgb(113, 112, 132);
  font-weight: bold;
}
</style>